<template>
    <div>
        <v-alert
            v-for="(item, index) in announcements"
                :key="index"
                :value="true"
                :color="getColor(item)"
                :icon="item.icon"
                outline
                class="rounded-4 mt-2"
        >
             <v-chip
                v-if="item.recipient"
                small
                outlined
                :class="isMobile?'recipient-chip-mobile':'recipient-chip'"
                dark
            >
                To: {{ item.recipient }}
            </v-chip>
  
            <div @click="showDetails(item)" class="header-clickable" title="Click to view details">
                <strong>{{ item.typeName }}</strong>
            </div>
            <div v-if="item.displayDuration" class="details-section">
                {{ formatSchedule(item) }}
            </div>
            <div class="details-section" v-html="item.title"></div>
        </v-alert>
     </div>
</template>

<script>

import companyAnnouncementsApi from '@/api/companyannouncements'

export default {
    data() {
        return {
            announcements: [],
            error: false,
            errorMessage: null
        }
    },
    methods: {
        showDetails(item) {
            this.$router.push(`/company/announcements/${item.companyAnnouncementId}`)
        },
        async getNowShowing() {
            try {
                // Load cached data first for fast UI
                const cachedData = localStorage.getItem('companyNotifications')
                if (cachedData) {
                    this.announcements = JSON.parse(cachedData)
                }

                // Fetch latest data
                const response = await companyAnnouncementsApi.getNowShowing()
                if (response && response.status === 200) {
                    this.announcements = response.data.items
                    localStorage.setItem('companyNotifications', JSON.stringify(this.announcements))
                }
            } catch (error) {
                this.error = true
                this.errorMessage = error.message || error
            }
        },
        formatSchedule(data) {
            const start = this.$moment(data.effectiveDate)
            const end = this.$moment(data.expirationDate)
            const today = this.$moment()

            const startDateLabel = today.isSame(start, 'day')
                ? `Today (${start.format('ddd')})`
                : start.format('MMM D (ddd)')

            const endDateLabel = today.isSame(end, 'day')
                ? `Today (${end.format('ddd')})`
                : end.format('MMM D (ddd)')

            // If start and end are the same day
            if (start.isSame(end, 'day')) {
                return `${startDateLabel} from ${start.format('h:mm A')} to ${end.format('h:mm A')}`
            }

            // If start and end are different days
            return `${startDateLabel} ${start.format('h:mm A')} to ${endDateLabel} ${end.format('h:mm A')}`
        },
        getColor(item) {
            // If API gives hex code, use it; otherwise fallback to Vuetify color name
            if (item.backgroundColor && item.backgroundColor.startsWith('#')) {
                return item.backgroundColor
            }
            return item.backgroundColor || 'primary'
        }
    },
    created() {
        this.getNowShowing()
    },
    computed: {},
}
</script>
<style scoped>
.header-clickable {
    cursor: pointer;
}
.header-clickable:hover {
    text-decoration: underline;
}
.recipient-chip {
    position: absolute;
    top: 8px;
    right: 5px;
    font-size: 10px;
}
.recipient-chip-mobile {
    margin-left:0px;
    font-size: 10px;
}
.details-section {
    color: #3b3b3b;
}
</style>
